import { inject, Injectable } from '@angular/core';
import { DataContextService, ResultWrapper } from '@seahorse/common';
import { Observable } from 'rxjs';
import { FolderStructureModel } from '../models/folder-structure.model';

@Injectable({
  providedIn: 'root',
})
export class FolderStructureDataService {
  private readonly _baseUrl = 'folder-structure';
  private _dataContextService = inject(DataContextService);

  get(
    objectMappingKey: string
  ): Observable<ResultWrapper<FolderStructureModel[]>> {
    return this._dataContextService.get<FolderStructureModel[]>(
      `${this._baseUrl}/${objectMappingKey}`
    );
  }

  add(
    model: FolderStructureModel
  ): Observable<ResultWrapper<FolderStructureModel>> {
    return this._dataContextService.post<FolderStructureModel>(
      this._baseUrl,
      model
    );
  }

  update(
    id: number,
    model: FolderStructureModel
  ): Observable<ResultWrapper<FolderStructureModel>> {
    return this._dataContextService.put<FolderStructureModel>(
      `${this._baseUrl}/${id}`,
      model
    );
  }

  delete(id: number): Observable<ResultWrapper<FolderStructureModel>> {
    return this._dataContextService.delete<FolderStructureModel>(
      `${this._baseUrl}/${id}`
    );
  }
}
